import { Col, Row } from "antd";

export const userProjectPermissions = {
  // GENERAL
  general: {
  view: false,
  import: false,
  export: false,
  },
  
  // DELIVERY NOTES
  delivery_notes: {
  generate: false,
  edit: false,
  edit_completed_delivery_notes: false,
  },
  
  // EDIT
  edit: {
  admin_add_edit_delete: false,
  newPriority: false,
  comments: false,
  status: false,
  template_fields: false,
  add_revisions: false,
  adjust_qty_manually: false,
  },
  
  // FABRICATION
  fabrication: {
  mark_received: false,
  mark_completed: false,
  update_supplier: false,
  add_attachments: false,
  },
  // QC RELEASE
  qc_release: {
  mark_received: false,
  mark_completed: false,
  update_supplier: false,
  add_attachments: false,
  },
  // CORROSION PROTECTION / DELIVERY TO WORKSHOP
  corrosion_protection: {
  mark_received: false,
  mark_completed: false,
  update_supplier: false,
  add_attachments: false,
  },
  
  // DELIVERY TO SITE
  delivery: {
  mark_received: false,
  mark_completed: false,
  update_supplier: false,
  add_attachments: false,
  },
  
  // SITE RECEIPT
  site_receipt: {
  mark_received: false,
  mark_completed: false,
  update_supplier: false,
  add_attachments: false,
  },
  
  // INSTALLATION
  installation: {
    mark_installed: false,
    add_attachments: false,
  },
};

export const initialEditingRowData = {
};

const handlePermissions = (params) => {
  let total = 0;
  Object?.entries(params).map((a) => {
    let [, isTrue] = a;
    if (isTrue) {
      total = total + 1;
    }
  });
  return Object?.entries(params)?.map((data, i) => {
    const [key, value] = data;
    let comma = total < i || total === 1 ? "" : ", ";
    if (value) {
      total = total - 1;
      return key.split("_").join("/") + comma;
    }
  });
};

const checkAnyTrueValue = (obj) => {
  let trueValueExist = false;
  if (obj) {
    Object.entries(obj)?.map((el) => {
      const [, value] = el;
      if (value) {
        trueValueExist = true;
      }
    });
  }
  return trueValueExist;
};

const permissionsCol = (permissions) =>
  Object?.entries(permissions)?.map((data) => {
    const [name, perObj] = data;
    const shouldRender = checkAnyTrueValue(perObj);

    let keyName = name === "document_control" ? "" : "document control ";
    return (
      shouldRender && (
        <Col span={24} className="name-col">
          <span>
            {keyName + name.split("_").join(" ")} - {handlePermissions(perObj)}
          </span>
        </Col>
      )
    );
  });

export const handlePermissionsCol = ({
  permissions,
  document_control_manager,
  project_manager,
}) => {
  const { document_control, revisions, distribution } = permissions;
  let updatedOrdered = { document_control, revisions, distribution };

  let rolesObj = {
    document_control_manager,
    project_manager,
  };

  let str = "";
  str = project_manager
    ? str +
      "project_manager".split("_").join(" ") +
      `${document_control_manager ? ", " : ""}`
    : str;

  str = document_control_manager
    ? str + "document_control_manager".split("_").join(" ")
    : str;

  return (
    <Row gutter={[0, 0]} className="permission-col">
      {(document_control_manager || project_manager) && (
        <Col span={24} className="name-col">
          <span>
            {
              "Project Roles - " + str
              // Object?.entries(rolesObj)?.map((ele) => {
              //   const [name, value] = ele;
              //   return value ? name.split("_").join(" ") : "";
              // })
            }
          </span>
        </Col>
      )}
      {permissionsCol(updatedOrdered)}
    </Row>
  );
};
